'use client';

import PricingInteractive from '@/app/(dashboard)/pricing/components/PricingInteractive';

export default function MarketingPricingSection() {
  return (
    <section id="pricing" className="mt-20 md:mt-36 pt-10">
      <div className="rounded-3xl bg-[#fff9f3] text-slate-900 px-4 md:px-8 pt-0 pb-0">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col items-center text-center mb-6">
            <h2 className="font-poppins text-[32px] md:text-[53px] font-bold sm:font-semibold tracking-tight leading-[1.2] text-black max-w-2xl mx-auto mb-5">
              Get early access & lock in Founder pricing for good
            </h2>
          </div>

          <div className="mt-6">
            <PricingInteractive />
          </div>
        </div>
      </div>
    </section>
  );
}

